import { UserCredentials } from '@botpress/webchat-client'
import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

export type WebchatClientState = {
  user?: UserCredentials
  conversationId?: string
}

type WebchatClientActions = {
  setUser: (userId?: UserCredentials) => void
  setConversationId: (conversationId: string) => void
  clearAll: () => void
}

type WebchatClientStore = WebchatClientState & WebchatClientActions

export type StorageLocation = 'sessionStorage' | 'localStorage'

const createWebchatClientStore = (storeName: string, storageLocation?: StorageLocation) =>
  create<WebchatClientStore>()(
    devtools(
      persist(
        (set) => ({
          setUser: (user) =>
            set((state) => ({
              ...state,
              user,
            })),
          setConversationId: (conversationId) =>
            set((state) => ({
              ...state,
              conversationId,
            })),
          clearAll: () => {
            set((state) => ({
              ...state,
              user: undefined,
              conversationId: undefined,
            }))
          },
        }),
        {
          name: storeName,
          storage: createJSONStorage(() => (storageLocation === 'sessionStorage' ? sessionStorage : localStorage)),
        }
      )
    )
  )
type BoundWebchatClientStore = ReturnType<typeof createWebchatClientStore>
class WebchatClientStores {
  private static _instances: { [key: string]: BoundWebchatClientStore } = {}
  private constructor() {}

  public static getInstance(name = 'bp-webchat', storageLocation?: StorageLocation): BoundWebchatClientStore {
    if (!WebchatClientStores._instances[name]) {
      WebchatClientStores._instances[name] = createWebchatClientStore(name, storageLocation)
    }
    return WebchatClientStores._instances[name]
  }
}

export const getUseWebchatClientStore = WebchatClientStores.getInstance
